import { createStyles, makeStyles } from '@material-ui/styles';
import themes from 'styles/themes';
export const useStyles = makeStyles(() =>
    createStyles({
        main: {
            padding: '16px 24px',
            overflowY: 'scroll',
        },
        personal: {
            display: 'flex',
            width: '100%',
            height: 'auto',
        },
        personalInfo: {
            margin: '0 16px',
            height: 'auto',
        },
        personalImg: {
            objectFit: 'cover',
            maxWidth: 72,
            maxHeight: 72,
            borderRadius: '50%',
            minWidth: '100%',
        },
        contnentPage: {
            height: '70vh',
            marginTop: 30,
            paddingBottom: 200,
            overflowY: 'scroll',
        },
        option: {
            background: themes.palette.common.white,
            borderRadius: 10,
            padding: 10,
            fontSize: 16,
            fontWeight: 400,
            color: themes.palette.primary.main,
            fontFamily: 'PoppinsRegular',
            listStyleType: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '85px',
            margin: '10px 0',
        },
        link: {
            textDecoration: 'none',
        },
    }),
);
